import React from 'react';
import { Shirt, Baby, Footprints, Package, Home, Sparkles } from 'lucide-react';
import { Card, CardContent } from './ui/card';

export const ProductsSection = ({ language }) => {
  const content = {
    en: {
      title: 'Wide Range of Products',
      subtitle: 'Everything You Need Under One Roof',
      categories: [
        { name: 'Ladies Wear', icon: Shirt, desc: 'Stylish collection' },
        { name: 'Gents Wear', icon: Shirt, desc: 'Trendy fashion' },
        { name: 'Kids Wear', icon: Baby, desc: 'Cute & comfortable' },
        { name: 'Footwear', icon: Footprints, desc: 'All styles' },
        { name: 'Plastic Items', icon: Package, desc: 'Daily necessities' },
        { name: 'Crockery', icon: Home, desc: 'Kitchen essentials' },
        { name: 'Homeware', icon: Home, desc: 'Home decor' },
        { name: 'Cosmetics', icon: Sparkles, desc: 'Beauty products' },
        { name: 'Toys', icon: Package, desc: 'Kids favorites' }
      ]
    },
    gu: {
      title: 'વસ્તુઓની વિશાળ શ્રેણી',
      subtitle: 'એક જ છત હેઠળ તમને જોઈતું બધું',
      categories: [
        { name: 'લેડીઝ વેર', icon: Shirt, desc: 'સ્ટાઇલિશ કલેક્શન' },
        { name: 'જેન્ટ્સ વેર', icon: Shirt, desc: 'ટ્રેન્ડી ફેશન' },
        { name: 'કિડ્સ વેર', icon: Baby, desc: 'સુંદર અને આરામદાયક' },
        { name: 'ફૂટવેર', icon: Footprints, desc: 'બધી શૈલીઓ' },
        { name: 'પ્લાસ્ટિક', icon: Package, desc: 'રોજિંદી જરૂરિયાતો' },
        { name: 'ક્રોકરી', icon: Home, desc: 'રસોડાની જરૂરિયાતો' },
        { name: 'હોમવેર', icon: Home, desc: 'ઘર સજાવટ' },
        { name: 'કોસ્મેટિક્સ', icon: Sparkles, desc: 'સૌંદર્ય ઉત્પાદનો' },
        { name: 'રમકડાં', icon: Package, desc: 'બાળકોના મનપસંદ' }
      ]
    }
  };

  const t = content[language];

  return (
    <section id="products" className="py-20 bg-white">
      <div className="container mx-auto px-4">
        <div className="text-center mb-12">
          <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-4">{t.title}</h2>
          <p className="text-xl text-gray-600">{t.subtitle}</p>
        </div>
        
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
          {t.categories.map((category, index) => {
            const Icon = category.icon;
            return (
              <Card 
                key={index}
                className="group hover:shadow-xl transition-all duration-300 transform hover:-translate-y-2 cursor-pointer border-2 hover:border-red-400"
              >
                <CardContent className="p-6">
                  <div className="bg-red-100 w-16 h-16 rounded-full flex items-center justify-center mb-4 group-hover:bg-red-600 transition-colors duration-300">
                    <Icon className="h-8 w-8 text-red-600 group-hover:text-white transition-colors duration-300" />
                  </div>
                  <h3 className="text-xl font-bold text-gray-900 mb-2">{category.name}</h3>
                  <p className="text-gray-600">{category.desc}</p>
                </CardContent>
              </Card>
            );
          })}
        </div>
      </div>
    </section>
  );
};